// extracted by mini-css-extract-plugin
export default {"breadcrumb":"index_breadcrumb__npuEQ","back":"index_back__+t3k-","icon":"index_icon__kc2eJ"};